<template>
  <nav>
    <ol class="breadcrumb">
      <li
        v-for="(crumb, ci) in crumbs"
        :key="ci"
        class="breadcrumb-item align-items-center  "
        style="text-decoration: none"
      >
        <h1
          style="margin-top:-8px;"
          class="btn text-primary"
          :class="{ disabled: isLast(ci, crumb) || crumb == 'Admin Menu' }"
          @click="selected(crumb)"
        >
          <span style="font-size: 14px;color:#004080;font-weight: bold; " > {{ crumb }} </span>
        </h1>
      </li>
    </ol>
  </nav>
</template>

<script>
import axios from "axios";
import router from "../router";
export default {
  props: ["crumb_params"],

  data: () => ({
    crumbs: [],
    machine_id: null,
    start_date: null,
    end_date: null,
  }),
  created() {
    this.set_crumbs_dict();
    console.log("crumb global variable", this.$crumbs_dict);
  },
  methods: {
    isLast(index, crumb = 0) {
      if (crumb === "Admin Menu" || crumb === "Report Menu") {
        return index === this.crumbs.length - 2;
      } else {
        return index === this.crumbs.length - 1;
      }
    },
    async set_crumbs_dict() {
      let params = `?route_name=${
        this.$route.name
      }&crumb_dict=${sessionStorage.getItem("crumbs_dict")}`;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getcrumblist${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      await axios(config).then((response) => {
        let data = JSON.parse(response.data.data);
        console.log("checking final data", data);
        this.crumbs = data.crumb_list;
        this.$crumbs_dict = data.crumb_dict;
        sessionStorage.setItem(
          "crumbs_dict",
          JSON.stringify(this.$crumbs_dict)
        );
      });
    },
    async updatecrumbslist(crumb) {
      let params = `?crumb_name=${crumb}`;
      let config = {
        method: "get",
        url: `${
          this.$config.backend_url
        }/updatecrumblist${params}&crumb_dict=${sessionStorage.getItem(
          "crumbs_dict"
        )}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      await axios(config).then((response) => {
        let data = response.data.data;
        console.log("checking final data", data);
      });
    },
    selected(crumb) {
      try {
        this.machine_id = this.crumb_params.machine_id;
      } catch (error) {
        console.log("error", error);
      }
      if (crumb == "Home") {
        this.clearcrumbsdict();
        router.push(sessionStorage.getItem("route_first_option"));
      } else if (this.machine_id == null) {
        this.$router.push({ name: `${this.$crumbs_dict[crumb].name}` });
        this.updatecrumbslist(crumb);
      } else {
        this.$router.push({
          name: `${this.$crumbs_dict[crumb].name}`,
          params: { macId: this.machine_id },
        });
        this.updatecrumbslist(crumb);
      }
    },
  },
};
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">
/* .breadcrumb {
  background-color: white;
  border: 2px dashed #0000cd;;
  border-radius: 0.89rem;
} */
</style>
